import SectionWrapper from '@/components/SectionWrapper'
import { BarChart, Trophy, TrendingUp } from 'lucide-react'

export default function Stats() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Stats</h1>
        <p className="text-muted-foreground mt-2">
          Track your performance and achievements across all games
        </p>
      </div>

      {/* Coming Soon Card */}
      <SectionWrapper>
        <div className="p-12 text-center">
          <div className="flex justify-center mb-4">
            <BarChart className="h-12 w-12 text-muted-foreground" />
          </div>
          <h2 className="text-xl font-semibold mb-2">Stats & Analytics Coming Soon</h2>
          <p className="text-muted-foreground max-w-md mx-auto">
            Detailed statistics, performance tracking, and personal achievements will be available here.
            We're working hard to bring you comprehensive analytics!
          </p>
        </div>
      </SectionWrapper>

      {/* Planned Features */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <SectionWrapper>
          <div className="p-6">
            <div className="flex items-center gap-3 mb-3">
              <TrendingUp className="h-5 w-5 text-muted-foreground" />
              <h3 className="font-semibold">Performance Trends</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              Track your improvement over time with detailed charts
            </p>
          </div>
        </SectionWrapper>

        <SectionWrapper>
          <div className="p-6">
            <div className="flex items-center gap-3 mb-3">
              <Trophy className="h-5 w-5 text-muted-foreground" />
              <h3 className="font-semibold">Achievements</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              Unlock badges and trophies as you play
            </p>
          </div>
        </SectionWrapper>

        <SectionWrapper>
          <div className="p-6">
            <div className="flex items-center gap-3 mb-3">
              <BarChart className="h-5 w-5 text-muted-foreground" />
              <h3 className="font-semibold">Game Statistics</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              Detailed breakdowns for each game you play
            </p>
          </div>
        </SectionWrapper>
      </div>
    </div>
  )
}